import {
  DalsiPredkladatelUuid as DalsiPredkladatelUuidGenerated,
  LegislativnyMaterialCreateApi,
  LegMaterialCreate,
  LegMaterialCreateStepEnum as activeStepGenerated,
} from 'elegislativa-frontend-ts-axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import LegislativnyMaterialCreateUpdate from '../../model/legislativnyMaterial/LegislativnyMaterialCreateUpdate';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';
import Predkladatel from '../../model/legislativnyMaterial/Predkladatel';
import Uuid from '../../model/Uuid';

const client = new LegislativnyMaterialCreateApi(apiConfiguration(elegislativaPrefixPath));

const map = (legMaterial: LegislativnyMaterialCreateUpdate, onlyValidate = true): LegMaterialCreate => ({
  nazov: legMaterial.nazov,
  typUuid: legMaterial.typ.uuid,
  oblastListUuid: legMaterial.oblastList.map(oblast => oblast.uuid),
  suvisiaceProcesy: legMaterial.suvisiaceProcesy.map(proces => proces.cisloLp),
  dalsiPredkladatelia: legMaterial.dalsiPredkladatelia
    .filter(dalsiPredkladatel => dalsiPredkladatel?.predkladatel)
    .map(predkladatel => mapDalsiPredkladatelUuid(predkladatel)),
  podnet: legMaterial.podnet,
  rezortneCislo: legMaterial.rezortneCislo,
  zodpovednyPredkladatel: legMaterial.zodpovednyPredkladatel?.uuid,
  hlavnyNovelizovanyPredpis: legMaterial.hlavnyNovelizovanyPredpis?.iri,
  novelizovanePredpisy: legMaterial.novelizovanePredpisy?.map(proces => proces.iri),
  activeStep: onlyValidate ? legMaterial.activeStep as activeStepGenerated : null,
});

const mapDalsiPredkladatelUuid = (dalsiPredkladatel: Predkladatel): DalsiPredkladatelUuidGenerated => ({
  predkladatelUuid: dalsiPredkladatel.predkladatel.uuid,
  organizaciaUuid: dalsiPredkladatel.organizacia.uuid,
});

// eslint-disable-next-line import/prefer-default-export
export const createLegMaterial = async (
  legMaterial: LegislativnyMaterialCreateUpdate,
  headers?: object,
): Promise<ClientResponse<Uuid>> => {
  const {
    status,
    data,
  } = await client.createLegMaterial(map(legMaterial, false), headers);
  return {
    responseCode: status,
    data,
  };
};

export const validateLegMaterial = async (
  legMaterial: LegislativnyMaterialCreateUpdate,
  headers?: object,
): Promise<ClientResponse<Uuid>> => {
  const { status } = await client.validateLegMaterial(map(legMaterial), headers);
  return {
    responseCode: status,
  };
};
